import React, { useState, useLayoutEffect, useRef, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Typography, TextField,
  Button,
  IconButton,
  ToggleButton,
  ToggleButtonGroup, Snackbar, CardMedia, InputAdornment, Badge
} from "@mui/material";
import { Add, Remove, ShoppingCart, ChevronLeft, ChevronRight, Close } from "@mui/icons-material";
import { useSaveShoppingBagMutation, useGetShoppingBagMutation } from "../../services/orders";
import { setOrderQty } from '../../features/authSlice';
import noImage from '../../images/noimage.png';

const API_URI = process.env.REACT_APP_API_URI;
// let sizes = [];
export default function CardDetail({record, setOpenDetail}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [mainImage, setMainImage] = useState(
    (record.imgs?`${API_URI}/uploads/products/${record.imgs}`:'')||record.imgSrc||noImage
  );
  const [saveShoppingBag, saveShoppingBagResult] = useSaveShoppingBagMutation();
  const [qty, setQty] = useState(1);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);
  const scrollRef = useRef(null);
  const [alert, setAlert] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);
  const [total, setTotal] = useState({qty: 0, amount: 0});

  const [colSizes, setColSizes] = useState({[record.arrColor[0]]: [] });
  const [color, setColor] = useState('');
  // const [size, setSize] = useState(sizes[0]);

  let thumbnails = record.Images?record.Images.split(';'):[];
  const thumbnailsEcom = record.ImageSrcs?record.ImageSrcs.split(';'):[];
  for(var i =0; i< thumbnails.length; i++){

    if(thumbnails[i] == '') thumbnails[i] = thumbnailsEcom[i];
    else thumbnails[i] = `${API_URI}/uploads/products/${thumbnails[i]}`;
  }
  
  useEffect(() => {
    setColor(record.arrColor[0]);
    const el = scrollRef.current;
    if (el) el.addEventListener("scroll", checkScroll);
    window.addEventListener("resize", checkScroll);
    return () => {
      if (el) el.removeEventListener("scroll", checkScroll);
      window.removeEventListener("resize", checkScroll);
      setColSizes({});
      setTotal({});
      setColor('');
    };
  }, []);

  useEffect(() => {
    if(!(colSizes[color] && colSizes[color].length)){
      const orderItems = JSON.parse(window.localStorage.getItem('orderItems')||"[]");
      const localItem = orderItems.filter(f=>f.StyleNo == record.StyleNo);
      let localSC = [];
      if(localItem && localItem.length){
        localSC = localItem.filter(f=>f.Colors == color);
      }
      let si = [];
      const arrColCupSize = record.col_cup_size?record.col_cup_size.split(';'):[];
      arrColCupSize.map(m=>{
        const arrSize = m.split('-');
        if(arrSize[0] == color){
          const size = `${arrSize[2].trim()}${arrSize[1].trim()}`;
          if(!si.find(f=>f.size == size)){
            const localSize = localSC.find(f1=>f1.size == size);
            si.push({size: size, qty: (localSize?localSize.quantity:0)});
          }
        }
      });
      setColSizes({...colSizes, [color]: si });
    }
  }, [color]);

  useEffect(() => {
    if(record.StyleNo){
      let tot = {qty: 0, amount: 0};
      const orderItems = JSON.parse(window.localStorage.getItem('orderItems')||"[]");
      const localItem = orderItems.filter(f=>f.StyleNo == record.StyleNo);
      if(localItem && localItem.length){
        record.arrColor.map(col=>{
          let localSC = [];
          if(localItem && localItem.length){
            localSC = localItem.filter(f=>f.Colors == col);
          }
          let si = [];
          const arrColCupSize = record.col_cup_size?record.col_cup_size.split(';'):[];
          arrColCupSize.map(m=>{
            const arrSize = m.split('-');
            if(arrSize[0] == col){
              const size = `${arrSize[2].trim()}${arrSize[1].trim()}`;
              if(!si.find(f=>f.size == size)){
                const localSize = localSC.find(f1=>f1.size == size);
                const qty = (localSize?localSize.quantity:0);
                const price = (localSize?localSize.saleprice:0);
                tot.qty = tot.qty + qty;
                tot.amount = tot.amount + (price*qty);
                si.push({size: size, qty: qty});
              }
            }
          });
          setColSizes({...colSizes, [col]: si });
        })
      }
      setTotal(tot);
    }
  }, [record.StyleNo]);

  useLayoutEffect(() => {// Run after layout
    checkScroll();
  }, [record]);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 0);
    setShowRight(el.scrollWidth > el.clientWidth + el.scrollLeft);
  };

  const scrollByAmount = (amount) => {
    scrollRef.current.scrollBy({ left: amount, behavior: "smooth" });
  };

  const addToCart = () => {
    navigate("/cart", { replace: true });
    // const item = {styleColCupSize: record.StyleNo + color + size
    //   , quantity: qty, saleprice: record.saleprice, price: record.price, promoid: record.promoid||0};

    // saveShoppingBag(item);
  };

  // useEffect(() => {
  //   if(saveShoppingBagResult.data)
  //   {
  //     const dt = JSON.parse(saveShoppingBagResult.data);
  //     if(dt.length){
  //       if(dt[0].ERROR)
  //         setAlert(dt[0].ERROR);
  //       else{
  //         const item = {styleColCupSize: record.StyleNo + color + size
  //           , quantity: qty, saleprice: record.saleprice, price: record.price, promoid: record.promoid||0};

  //         let orderItems = JSON.parse(window.localStorage.getItem('orderItems')||"[]");
  //         const index = orderItems.findIndex(f=>f.styleColCupSize == item.styleColCupSize);
  //         if(index >= 0){
  //           orderItems[index] = {...item};
  //         }
  //         else
  //           orderItems.push({...item});
  //         dispatch(setOrderQty(orderItems.length));
  //         window.localStorage.setItem('orderItems', JSON.stringify(orderItems));
  //         setOpenDetail(false);
  //       }
  //     }
  //   }
  // }, [saveShoppingBagResult]);

  const onChangeQty=(value)=>{
    const numericValue = Number(value);
    let changeQty = 1;
    if(Number.isInteger(numericValue))
      changeQty = (parseInt(value) < 1 ? 1 : parseInt(value));
    setQty(changeQty);
  }

  const handleImageLoad = () => {
    setImgLoaded(true);
  };

  const handleImageError = () => {
    setImgLoaded(true);
    setMainImage(noImage);
  };

  const onChangeColQty=async(index, value)=>{
    try {
      let cs = {...colSizes};
      let changeQty = parseInt(cs[color][index].qty||0) + value;
      changeQty = changeQty < 0 ? 0 : changeQty;

      const item = {styleColCupSize: record.StyleNo + color + cs[color][index].size
        , quantity: changeQty, saleprice: record.saleprice, price: record.price, promoid: record.promoid||0};
      const result = await saveShoppingBag(item).unwrap();
      const dt = JSON.parse(result);
      if(dt[0].ERROR)
        setAlert(dt[0].ERROR);
      else{
        cs[color][index].qty = changeQty;
        setColSizes(cs);
        saveLocal({...item, StyleNo: record.StyleNo, Colors: color, size: cs[color][index].size});
      }
    } catch (err) {
      setAlert("Lỗi kết nối!");
      console.error(err);
    }
  }

  const onReplaceColQty=async(index, value)=>{
    try {
      let cs = {...colSizes};
      let changeQty = cs[color][index].qty||0;
      const numericValue = Number(value);
      if(Number.isInteger(numericValue))
        changeQty = (parseInt(numericValue) < 0 ? 0 : parseInt(numericValue));
      
      const item = {styleColCupSize: record.StyleNo + color + cs[color][index].size
        , quantity: changeQty, saleprice: record.saleprice, price: record.price, promoid: record.promoid||0};
      const result = await saveShoppingBag(item).unwrap();
      const dt = JSON.parse(result);
      if(dt[0].ERROR)
        setAlert(dt[0].ERROR);
      else{
        cs[color][index].qty = changeQty;
        setColSizes(cs);
        saveLocal({...item, StyleNo: record.StyleNo, Colors: color, size: cs[color][index].size});
      }
    } catch (err) {
      setAlert("Lỗi kết nối!");
      console.error(err);
    }
  }

  const saveLocal = (item)=>{
    let orderItems = JSON.parse(window.localStorage.getItem('orderItems')||"[]");
    const index = orderItems.findIndex(f=>f.styleColCupSize == item.styleColCupSize);
    if(index >= 0){
      orderItems[index] = {...item};
    }
    else
      orderItems.push({...item});
    dispatch(setOrderQty(orderItems.length));
    window.localStorage.setItem('orderItems', JSON.stringify(orderItems));
    
    let tot =  orderItems.filter((i) => i.StyleNo == record.StyleNo).reduce((sum, item) => {
      return {
        qty: sum.qty + item.quantity,
        amount: sum.amount + (item.saleprice*item.quantity),
      };
    }, { qty: 0, amount: 0 });
    setTotal(tot);
  }

  return (
    <Box sx={{ p: { xs: 2, sm: 4 } }}>
      <Grid container spacing={0}>
        {/* LEFT - Gallery (desktop layout) */}
        <Grid item xs={12} md={6} sx={{
              maxWidth: { xs: "100%", md: "60%"},
              width: { xs: "100%", md: "60%" }
            }}>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 2,
              paddingRight: { xs: 0, md: '100px' }
            }}
          >
            {/* Thumbnails vertical (desktop) */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {thumbnails.map((img, i) => (
                <Badge max={999} color="warning"
                  badgeContent={colSizes[record.arrColor[i]]&&colSizes[record.arrColor[i]].length?colSizes[record.arrColor[i]].reduce((sum, j)=>sum+j.qty, 0):0}>
                <Box
                  sx={{
                    width: 64,
                    height: 90,
                    border: color === record.arrColor[i] ? "2px solid black" : "1px solid #ddd",
                    borderRadius: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    boxSizing: "border-box",
                    position: "relative",
                    cursor: "pointer",
                  }}
                  onClick={() => {setMainImage(img||noImage); setColor(record.arrColor[i]);}}
                >
                  <Typography sx={{ textAlign: "center", width: '100%', borderBottom: '1px solid #e9e6e6' }}>
                    {record.arrColor && record.arrColor[i]}
                  </Typography>
                  <Box
                    key={i}
                    component="img"
                    src={img||noImage}
                    alt="&nbsp; &nbsp; &nbsp; No Image"
                    sx={{
                      width: 60,
                      height: 60,
                      objectFit: "cover",
                      textAlign: "center", lineHeight: '18px', color: 'silver'
                    }}
                  />
                </Box>
                </Badge>
              ))}
            </Box>

            {/* Main Image */}
            <Box
              alt="main"
              sx={{
                flex: 1,
                maxHeight: 700,
                width: '100%',
                objectFit: "contain",
                borderRadius: 2,
                border: "1px solid #eee",
              }}
            >
              <CardMedia
                component="img"
                // height="280"
                image={mainImage}
                alt="Product Image"
                onLoad={handleImageLoad}
                onError={handleImageError}
                style={{
                  filter: imgLoaded ? 'none' : 'blur(5px)',
                  transition: 'filter 0.3s ease-in-out',
                  cursor: 'pointer'
                }}
                onClick={()=>setOpenDetail(true)}
              />
            </Box>
          </Box>

          {/* Mobile layout (main image + thumbnails row below) */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <Box
              alt="main"
              sx={{
                width: "100%",
                objectFit: "contain",
                borderRadius: 2,
                border: "1px solid #eee",
              }}
            >
              <CardMedia
                component="img"
                // height="280"
                image={mainImage}
                alt="Product Image"
                onLoad={handleImageLoad}
                onError={handleImageError}
                style={{
                  filter: imgLoaded ? 'none' : 'blur(5px)',
                  transition: 'filter 0.3s ease-in-out',
                  cursor: 'pointer'
                }}
                onClick={()=>setOpenDetail(true)}
              />
            </Box>
            <Box
              sx={{
                position: "relative",
                display: "flex",
                // justifyContent: "center",
                // gap: 1,
                mt: 1,
              }}
            >
              {showLeft && (
                <IconButton
                  onClick={() => scrollByAmount(-100)}
                  sx={{
                    position: "absolute",
                    left: -15, top: -1,
                    zIndex: 1,
                    bgcolor: "white",
                    boxShadow: 1,
                    height: '90px !important',
                    width: 20,
                    borderRadius: "0 20px 20px 0",
                    p: 0, pr: 0.5
                  }}
                >
                  <ChevronLeft sx={{ color: '#36bbff' }} />
                </IconButton>
              )}

              <Box
                ref={scrollRef}
                sx={{
                  display: "flex",
                  overflowX: "auto",
                  // gap: 1,
                  //pt: 1, pb: 1,
                  scrollbarWidth: "none", // Firefox
                  "&::-webkit-scrollbar": { display: "none" }, // Chrome/Safari
                }}
              >
                {thumbnails.map((img, i) => (
                  <Badge max={999} color="warning" sx={{ "& .MuiBadge-badge": {top: '3px', right: '5px'}, mt: 1, mr: 1 }}
                    badgeContent={colSizes[record.arrColor[i]]&&colSizes[record.arrColor[i]].length?colSizes[record.arrColor[i]].reduce((sum, j)=>sum+j.qty, 0):0}>
                  <Box
                    sx={{
                      width: 64,
                      height: 90,
                      border: color === record.arrColor[i] ? "2px solid black" : "1px solid #ddd",
                      borderRadius: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      boxSizing: "border-box",
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={() => {setMainImage(img||noImage); setColor(record.arrColor[i]);}}
                  >
                    <Box
                      key={i}
                      component="img"
                      src={img||noImage}
                      alt="&nbsp; &nbsp; &nbsp; No Image"
                      sx={{
                        width: 60,
                        height: 60,
                        objectFit: "cover",
                        textAlign: "center", lineHeight: '18px', color: 'silver'
                      }}
                    />
                    <Typography sx={{ textAlign: "center", width: '100%', borderTop: '1px solid #e9e6e6' }}>
                      {record.arrColor && record.arrColor[i]}
                    </Typography>
                  </Box>
                  </Badge>
                ))}
              </Box>
              {showRight && (
                <IconButton size="small"
                  onClick={() => scrollByAmount(100)}
                  sx={{
                    position: "absolute",
                    right: -15, top: -1,
                    zIndex: 1,
                    bgcolor: "white",
                    boxShadow: 1,
                    height: '90px !important',
                    width: 20,
                    borderRadius: "20px 0 0 20px",
                    p: 0, pl: 0.5
                  }}
                >
                  <ChevronRight sx={{ color: '#36bbff' }} />
                </IconButton >
              )}
            </Box>
          </Box>
        </Grid>

        {/* RIGHT - Info */}
        <Grid item xs={12} md={6} 
          sx={{
              maxWidth: { xs: "100%", md: "40%"},
              width: { xs: "100%", md: "40%" },
              marginBottom: { xs: "50px", md: 0 }
            }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: "bold", mt: {xs: 1, md: 0} }}>
              {record.ProductName}
            </Typography>

            <Typography variant="caption" color="text.secondary" sx={{ mb: 1 }}>
              {record.StyleNo}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
              <Typography variant="body1" sx={{ color: 'red', fontWeight: 'bold' }}>
                {record.saleprice?record.saleprice.toLocaleString('en-US'):0}₫
              </Typography>
              <Typography
                variant="body2"
                sx={{ textDecoration: 'line-through', color: '#888' }}
              >
                {record.price?record.price.toLocaleString('en-US'):0}₫
              </Typography>
            </Box>

            {/* Sizes */}
            <Typography sx={{ mt: 2, mb: 1 }}>Chọn Kích Cỡ, Số Lượng:</Typography>
            <ToggleButtonGroup
              // value={size}
              exclusive
              // onChange={(e, val) => val && setSize(val)}
              sx={{ flexWrap: "wrap", gap: 1 }}
            >
              {colSizes[color]&&colSizes[color].map(({size: si, qty: qt}, index) => (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <ToggleButton key={si} value={si} sx={{ minWidth: 60, height: '35px', margin: 0, borderBottom: 'none'
                      , borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderTopLeftRadius: '4px !important', borderTopRightRadius: '4px !important' }}>
                    {si}
                  </ToggleButton>
                  <TextField
                    size="small" placeholder="0"
                    value={qt}
                    sx={{ width: 60, mx: 1, m: 0, "& .MuiInputBase-root": { borderTopLeftRadius: 0, borderTopRightRadius: 0, padding: 0 } }}
                    onChange={(e) => onReplaceColQty(index, e.target.value)}
                    slotProps={{
                      input: {
                        inputProps: {
                          inputMode: 'numeric',
                          pattern: '[0-9]*',
                          maxLength: 3, width: '100%', 
                          sx: { borderRadius: 0, textAlign: "center", padding: '2px' }
                        },
                        startAdornment: (
                          <InputAdornment position="start" sx={{ margin: 0, paddingLeft: '3px', cursor: 'pointer' }}
                          onClick={() => onChangeColQty(index, -1)}>
                            <Remove sx={{width: '10px', color: 'blue'}} />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end" sx={{ margin: 0, paddingRight: '3px', cursor: 'pointer' }}
                          onClick={() => onChangeColQty(index, 1)}>
                            <Add sx={{width: '10px', color: 'blue'}} />
                          </InputAdornment>
                        )
                      }
                    }}
                  />
                </Box>
              ))}
            </ToggleButtonGroup>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 2 }}>
              <Typography sx={{color: 'blue', width: '45%'}}>Tổng Số Lượng: {total.qty || 0}</Typography>
              <Typography sx={{color: 'red', width: '55%', textAlign: 'right'}}>Tạm Tính: {total.amount ? total.amount.toLocaleString('en-US'):0}₫</Typography>
            </Box>
            {/* Quantity */}
            {/* <Typography sx={{ mt: 2, mb: 1 }}>Số Lượng:</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton onClick={() => setQty(Math.max(1, qty - 1))}>
                <Remove />
              </IconButton>
              <TextField
                size="small"
                value={qty}
                sx={{ width: 55, mx: 1 }}
                onChange={(e) => onChangeQty(e.target.value||1)}
                slotProps={{
                  input: {
                    inputProps: {
                      inputMode: 'numeric',
                      pattern: '[0-9]*',
                      style: { textAlign: "center" },
                      maxLength: 3
                    }
                  }
                }}
              />
              <IconButton onClick={() => setQty(qty + 1)}>
                <Add />
              </IconButton>
            </Box> */}

            {/* Add to cart */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                variant="contained"
                color="primary"
                // fullWidth
                sx={{ mt: 2, py: 1.5, fontWeight: "bold", width: '50%' }}
                startIcon={<ShoppingCart />}
                onClick={()=>addToCart()}
              >
                MUA NGAY
              </Button>

              <Button
                variant="contained"
                color="warning"
                // fullWidth
                sx={{ mt: 2, py: 1.5, fontWeight: "bold", width: '50%' }}
                startIcon={<Close />}
                onClick={()=>setOpenDetail(false)}
              >
                CHỌN TIẾP
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
        // action={action}
      />
    </Box>
  );
}
